import styled, { css } from 'styled-components'

interface IProps {
  type: LabelButtonType
  content: string | JSX.Element
}

type LabelButtonType = 'success' | 'danger' | 'secondary' | 'primary' | 'warning'
interface IStyleProps {
  type: LabelButtonType
}

export const LabelButton = ({ type, content }: IProps) => {
  return (
    <Div type={type}>
      <div className="label-btn">{content}</div>
    </Div>
  )
}

const Div = styled.div<IStyleProps>`
  .label-btn {
    height: 2rem;
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 4px 10px;
    border-radius: 8px;
    font-family: Milliard;
    font-size: 0.75rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;

    ${({ theme, type }) => {
      switch (type) {
        case 'danger':
          return css`
            border: solid 1px ${theme.colors.error.lighter};
            background-color: ${theme.colors.error.lightest};
            color: ${theme.colors.error.darker};
          `
        case 'primary':
          return css`
            border: solid 1px ${theme.colors.primary.lighter};
            background-color: ${theme.colors.primary.lightest};
            color: ${theme.colors.primary.darker};
          `
        case 'secondary':
          return css`
            border: solid 1px ${theme.colors.secondary.lighter};
            background-color: ${theme.colors.secondary.lightest};
            color: ${theme.colors.secondary.darker};
          `
        case 'warning':
          return css`
            border: solid 1px ${theme.colors.warning.lighter};
            background-color: ${theme.colors.warning.lightest};
            color: ${theme.colors.warning.darker};
          `
      }
    }}
  }
`
